export enum UserGroup {
    SYS_ADMIN = 'SYS_ADMIN',
    ADMIN = 'ADMIN',
    USER = 'USER'
}

export interface AuthUser {
    id?: string;
    name?: string | null;
    surname?: string | null;
    account?: string | null;
    email?: string | null;
    status?: string | null;
    group?: UserGroup | null;
    note?: string | null;
    tempId?: string | null;
    cognitoUserName?: string | null;
    userSaml?: boolean;
}

export const ERROR_REASON_NOT_ENABLED = 'not-enabled';
